import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.8349 2.34941C14.5801 0.2338 18.5351 0.434046 21.0512 2.95015C23.3963 5.2953 23.7296 8.89044 22.0511 11.5909C21.9981 11.4182 21.9365 11.2417 21.8649 11.063C21.1694 9.32861 19.582 7.5312 16.278 6.92007C13.664 6.43657 12.6301 5.11266 12.1837 3.99943C11.9485 3.41294 11.8634 2.84701 11.8387 2.424C11.8372 2.39855 11.836 2.37367 11.8349 2.34941Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.0837 4.01809L2.31284 11.789L5.49378 14.9699L1.95782 18.5059C0.981508 19.4822 0.981508 21.0651 1.95782 22.0414C2.93413 23.0177 4.51704 23.0177 5.49335 22.0414L9.02932 18.5055L12.2123 21.6885L20.3602 13.5406C20.3589 13.491 20.3568 13.4383 20.3535 13.3828C20.3288 12.9598 20.2437 12.3938 20.0085 11.8074C19.5622 10.6941 18.5282 9.37021 15.9142 8.88671C12.6102 8.27559 11.0228 6.47818 10.3274 4.74375C10.2281 4.49626 10.1481 4.25296 10.0837 4.01809Z"}}]};

const PopsicleFilled = Vue.extend<IconProps>({
  name: 'PopsicleFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'popsicle-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PopsicleFilled;
